import { render, staticRenderFns } from "./promo-other-sales.vue?vue&type=template&id=3dd3db48"
import script from "./promo-other-sales.vue?vue&type=script&lang=js"
export * from "./promo-other-sales.vue?vue&type=script&lang=js"
import style0 from "./promo-other-sales.vue?vue&type=style&index=0&id=3dd3db48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports